import React, { useEffect, useState } from "react";
import { Button, Card } from "@material-ui/core";
import TableContainer from "@material-ui/core/TableContainer";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import { TextField, IconButton } from "@material-ui/core";
import { SearchOutlined, Close, Check, Visibility } from "@material-ui/icons";
import { Dialog, DialogActions, DialogTitle, Pagination, Tooltip, Divider } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {APPROVAL} from "../../common/constants";
import AjaxHelper from "../../apis/apiRequest";
import { startLoading, stopLoading } from "../../actions/loadingAction";
import { errorSnackbar, successSnackbar } from "../../actions/snackbarActions";
import { Endpoint,Status } from "../../apis/apiConstants";
import { useDispatch } from "react-redux";
import NodataComponent from "../../components/NodataComponent";
export default function NewsApproval() {
  const [news, setNews] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [selectedNews, setSelectedNews] = useState(null);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
 const dispatch = useDispatch();
  useEffect(() => {
    getAllNews();
  }, []);

  const getAllNews = (page, search) => {
    dispatch(startLoading);
    AjaxHelper.getApi(
      navigate,
      Endpoint.GET_NEWS_APPROVALS,
      {},
      { page, search }
    )
      .then((response) => {
        dispatch(stopLoading);
        if (response.data.status === Status.API_SUCCESS) {
          setNews(response.data.data);
          console.log(response.data.data);
          setSelectedNews(response.data.data[0]);
        } else if (response.data.status === Status.API_NO_CONTENT) {
          setNews([]);
          errorSnackbar(response.data.message);
        } else {
          errorSnackbar(response.data.message);
        }
      })
      .catch((error) => {
        dispatch(stopLoading);
        dispatch(errorSnackbar("Error in fetching News."));
      });
  };

  const getNewsView = () => {
    return news.map((newsItem) => (
      <TableRow key={newsItem._id}>
        <TableCell>{newsItem.createdBy}</TableCell>
        <TableCell>{newsItem.headline + " " + newsItem.description}</TableCell>
        <TableCell align="center">
          <Tooltip title={"View"}>
            <IconButton
              onClick={() => {
                setSelectedNews(newsItem);
                handleClickOpen();
              }}
            >
              <Visibility color={"primary"} />
            </IconButton>
          </Tooltip>
          <Tooltip title={"Approve"} className={"approve-icon"}>
            <IconButton onClick={() => {}}>
              {/* Handle approve */}
              <Check />
            </IconButton>
          </Tooltip>
          <Tooltip title={"Reject"} className={"reject-icon"}>
            <IconButton onClick={() => {}}>
              {/* Handle reject */}
              <Close />
            </IconButton>
          </Tooltip>
        </TableCell>
      </TableRow>
    ));
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div className={"news-component d-flex flex-column p-md-3"}>
      <div className="mb-3 col-md-3 col-sm-12">
        <TextField
          fullWidth
          placeholder="Search"
          value={searchText}
          onChange={(event) => {
            setSearchText(event.target.value);
          }}
          InputProps={{
            endAdornment: (
              <IconButton onClick={() => getAllNews(1, searchText)}>
                <SearchOutlined />
              </IconButton>
            ),
          }}
        />
      </div>
      <Card className="innerCard mt-3 " variant="outlined">
        <TableContainer component={Paper}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow className={"background-color-head"}>
                <TableCell>
                  <span className={"font-bold font-18"}>User</span>
                </TableCell>
                <TableCell>
                  <span className={"font-bold font-18"}>News</span>
                </TableCell>
                <TableCell align="center">
                  <span className={"font-bold font-18"}>Action</span>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>{getNewsView()}</TableBody>
          </Table>
        </TableContainer>
        {news.length > 0 ? null : <NodataComponent />}
        {/* Pagination */}
        <Pagination
          className={"pagination"}
        //   count={newsPages}
          page={currentPage}
          variant="outlined"
          shape="rounded"
          onChange={(event, page) => {
            setCurrentPage(page);
            getAllNews(page, searchText);
          }}
        />
      </Card>
      {/* Dialog for detailed view */}
      <Dialog fullScreen open={open} onClose={handleClose}>
        <DialogTitle className={"background-color-head"}>
          <span className={"font-bold font-18"}>
            {selectedNews
              ? selectedNews.title +
                " " +
                selectedNews.firstName +
                " " +
                selectedNews.lastName +
                " (" +
                selectedNews.userCode +
                ")"
              : ""}
          </span>
        </DialogTitle>
        <Divider />
        {/* Additional details view */}
        <DialogActions>
          <Button onClick={handleClose}>Ok</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
